import React from "react";
import { View } from "react-native";
import LanguageSection from "./language-section";
import NotificationsSection from "./notifications-section";
import CreditsSection from "./credits-section";

const General = () => {
  return (
    <View className="flex-col gap-8">
      <LanguageSection />
      <NotificationsSection />
      <CreditsSection />
    </View>
  );
};

export default General;
